import { BaseSkeletonTheme } from "./BaseSkeletonTheme";

export default BaseSkeletonTheme;
